import { generateReactHelpers } from '@uploadthing/react';

/** Single source of truth for the UploadThing route handler URL */
const UPLOADTHING_URL = `${import.meta.env.VITE_API_URL}upload`;

export const { useUploadThing } = generateReactHelpers({
  url: UPLOADTHING_URL,
});
